import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { forwardRef } from 'react';
export type AddressDropdownItemProps = {
  ariaSelected: boolean;
  disableHoverStyles: boolean;
  highlighted: boolean;
  id?: string;
  onClick: (event: React.MouseEvent<HTMLLIElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLLIElement>) => void;
  onMouseMove: (event: React.MouseEvent<HTMLLIElement>) => void;
  subtitle: string;
  title: string;
};
const AddressDropdownItem = forwardRef<HTMLLIElement, AddressDropdownItemProps>((t0, ref) => {
  const $ = _c(15);
  const {
    ariaSelected,
    disableHoverStyles,
    highlighted,
    id,
    onClick,
    onKeyDown,
    onMouseMove,
    subtitle,
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <div className="fp-dropdown-item-title text-body-2 mb-1">{title}</div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== subtitle) {
    t2 = <div className="fp-dropdown-item-secondary text-body-2">{subtitle}</div>;
    $[2] = subtitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaSelected || $[5] !== disableHoverStyles || $[6] !== highlighted || $[7] !== id || $[8] !== onClick || $[9] !== onKeyDown || $[10] !== onMouseMove || $[11] !== ref || $[12] !== t1 || $[13] !== t2) {
    t3 = <li className="fp-dropdown-item cursor-pointer mb-1 py-1 px-4 [&>p:first-child]:mb-1" data-dd-privacy="mask" aria-selected={ariaSelected} data-disable-hover-styles={disableHoverStyles} data-highlighted={highlighted} id={id} onClick={onClick} onKeyDown={onKeyDown} onMouseMove={onMouseMove} ref={ref} role="option">{t1}{t2}</li>;
    $[4] = ariaSelected;
    $[5] = disableHoverStyles;
    $[6] = highlighted;
    $[7] = id;
    $[8] = onClick;
    $[9] = onKeyDown;
    $[10] = onMouseMove;
    $[11] = ref;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
});
export default AddressDropdownItem;